<template>
  <!-- Quote-reply header rendered above the message body inside the
       bubble. Click to jump to the original message. Tombstoned
       targets render an "(message deleted)" placeholder so the user
       still has context. -->
  <!-- Width: the lines WRAP (line-clamp) instead of `truncate`. A
       nowrap line makes the whole snippet the bubble's minimum width,
       and since the bubble shrink-wraps its content it grew past the
       panel edge on long quotes. -->
  <button
    v-if="preview"
    type="button"
    class="w-full min-w-0 max-w-full flex items-stretch gap-2 mb-1.5 text-left rounded-md overflow-hidden border-l-2 transition-colors"
    :class="isOwn
      ? 'border-white/60 bg-white/[0.08] hover:bg-white/[0.12]'
      : 'border-primary/60 bg-primary/[0.06] hover:bg-primary/[0.10]'"
    @click.stop="$emit('jump', preview.id)"
  >
    <div class="px-2 py-1 min-w-0 flex-1">
      <p
        class="flex items-center gap-1 text-[11px] font-semibold leading-4 min-w-0"
        :class="isOwn ? 'text-white/85' : 'text-primary'"
      >
        <NuxtIcon name="mdi:reply" class="shrink-0 text-[12px]" aria-hidden="true" />
        <span class="line-clamp-1 [overflow-wrap:anywhere]">{{ $t('chat.reply.replying_to', { name: preview.authorName }) }}</span>
      </p>
      <p
        v-if="!preview.deletedAt"
        class="text-xs leading-4 line-clamp-2 [overflow-wrap:anywhere]"
        :class="isOwn ? 'text-white/70' : 'text-text-muted'"
      >{{ preview.bodySnippet || '—' }}</p>
      <p
        v-else
        class="text-xs italic text-text-dim"
      >{{ $t('chat.reply.deleted') }}</p>
    </div>
  </button>
</template>

<script setup lang="ts">
type ReplyPreview = {
  id: string
  authorName: string
  bodySnippet: string
  deletedAt: string | null
}

defineProps<{
  preview: ReplyPreview | null
  isOwn?: boolean
}>()

defineEmits<{
  jump: [messageId: string]
}>()
</script>
